// File: /src/components/dashboard/DashboardHeader.js

import React from 'react';

const DashboardHeader = ({ user, loading }) => (
	<header className="dashboard-header">
		<h1>Dashboard</h1>
		{!loading && user && (
			<p className="welcome-message">Bem-vindo, {user.name}!</p>
		)}
	</header>
);

export default DashboardHeader;
